import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - Highlights Fixed Columns';

export default function AOClpHighlightsFixedColumns() {
  const initiateTracking = () => {
    $('.js-ao-clp-highlights-fixed-columns__text a').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');
      const clickedElementLabel = $clickedElement.text().trim();

      if (!clickedElementLink) return;

      sendGoogleEvent(
        EVENT_CATEGORY,
        clickedElementLink,
        clickedElementLabel,
      );
    });
  };

  const initiate = () => initiateTracking;

  return { initiate };
}
